export const updateCurrentFiltersInLocalStore = (get) => () => {
  const { page, sortingField, sortingOrder, searchField } = get();

  localStorage.setItem(
    "response-filters",
    JSON.stringify({
      page,
      sortingField,
      sortingOrder,
      searchField,
    })
  );
};
export const getStateFromLocalStore = (set) => () => {
  const { page, sortingField, sortingOrder, searchField } = JSON.parse(
    localStorage.getItem("response-filters")
  );
  set({
    page,
    sortingField,
    sortingOrder,
    searchField,
  });
};
